import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  PartnershipFormData,
  partnershipFormService,
} from "../services/partnershipFormService";

interface PartnershipState {
  isSubmitting: boolean;
  lastSubmitStatus: "success" | "error" | null;
  error: string | null;
}

const initialState: PartnershipState = {
  isSubmitting: false,
  lastSubmitStatus: null,
  error: null,
};

export const sendPartnershipForm = createAsyncThunk(
  "partnership/sendForm",
  async (formData: PartnershipFormData) => {
    await partnershipFormService(formData);
    return { success: true };
  }
);

const partnershipSlice = createSlice({
  name: "partnership",
  initialState,
  reducers: {
    clearStatus: (state) => {
      state.lastSubmitStatus = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendPartnershipForm.pending, (state) => {
        state.isSubmitting = true;
        state.lastSubmitStatus = null;
        state.error = null;
      })
      .addCase(sendPartnershipForm.fulfilled, (state) => {
        state.isSubmitting = false;
        state.lastSubmitStatus = "success";
        state.error = null;
      })
      .addCase(sendPartnershipForm.rejected, (state, action) => {
        state.isSubmitting = false;
        state.lastSubmitStatus = "error";
        state.error = action.error.message || "Failed to send message";
      });
  },
});

export const { clearStatus } = partnershipSlice.actions;
export default partnershipSlice.reducer;
